<template>
    <section 
        v-if="state.processing === true && shouldRender !== false" 
        class="loader"
    >
        <div class="loader-wrapper">
            <div class="loader-icon"></div>
            <p class="loader-text">{{ $t("ui.loader.text")}}</p>
        </div>
    </section>
</template>
<script>
import { mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
export default {
    props: {
        shouldRender: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
            }),
        };
    },
};
</script>